export const editNavKey = {
    ADMIN: 'ADMIN-ONLY',
    GENERAL: 'GENERAL',
    CONTACT_INFORMATION: 'CONTACT-INFORMATION',
    MEDICAL_DETAILS: 'MEDICAL-DETAILS',
    HLA_INFORMATION: 'HLA-INFO',
    RECORDS: 'RECORDS',
    FINANCIAL_INFORMATION: 'FIN-INFO',
    ACTIVITY_LOG: 'ACTIVITY-LOG',
    DONOR_DECLINES: 'DONOR-DECLINES',
    POST_TRANSPLANT: 'POST-TRANSPLANT',
    PAIRED_DONORS: 'PAIRED-DONORS',
    ANTIBODY_SCREENINGS: 'ANTIBODY-SCREENINGS'
};
